import { LazyBackground } from '../Components/LazyBackground/types';

export const Backgrounds: LazyBackground[] = [
	{
		src: '/_n/images/onboarding/sky.webp',
		screen: 'start',
		loadScreen: 'start',
		flow: 'stress',
	},
	{
		src: '/_n/images/onboarding/quality-of-life-testimonial.webp',
		screen: 'qualityOfLife',
		isStretchedMobile: true,
		loadScreen: 'stressSource',
		flow: 'stress',
		hasGrayFade: true,
	},
	{
		src: '/_n/images/sleep-onboarding/daily-commitment-testimonial.webp',
		screen: 'dailyCommitment',
		loadScreen: 'meditationExperience',
		flow: 'stress',
		hasGrayFade: true,
	},
	{
		src: '/_n/images/sleep-onboarding/night-lake.webp',
		screen: 'start',
		loadScreen: 'start',
		flow: 'sleep',
	},
	{
		src: '/_n/images/sleep-onboarding/night-tree.webp',
		screen: 'preferencesTransition',
		loadScreen: 'miracleWorker',
		flow: 'sleep',
	},
	{
		src: '/_n/images/sleep-onboarding/asset-testimonial-image-1.webp',
		screen: 'miracleWorker',
		loadScreen: 'fallStayAsleep',
		flow: 'sleep',
		hasGrayFade: true,
	},
	{
		src: '/_n/images/sleep-onboarding/daily-commitment-testimonial.webp',
		screen: 'dailyCommitment',
		loadScreen: 'sleepNowLater',
		flow: 'sleep',
		hasGrayFade: true,
	},
];
